import { Button, ButtonProps } from 'antd';
import AddIcon from '@/assets/icons/add.svg?react';
import { ReactNode } from 'react';

const CreateButton = (
  props: ButtonProps & {
    text?: ReactNode;
  }
) => {
  const { text = '创建', ...rest } = props;
  return (
    <Button type="primary" icon={<AddIcon />} {...rest}>
      {text}
    </Button>
  );
};
export default CreateButton;
